import React, { useState, useContext, useEffect } from "react";
import BusquedaClienteContextProvider, {
    BusquedaClienteContext,
    ACTIONS
} from "../../context/BusquedaClienteProvider";
import "../../styles/busquedaCliente.scss";
import { ApplicationPropertiesContext } from "../../../../common/context/ApplicationPropertiesProvider"
import BusquedaTable from "../BusquedaTable";
import Loading from "../../../../common/components/Loading"
import { CGE } from "../../../../common/components/CGE";
import { getPathName } from "../../../../common/utils/utilsFunc";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

const NroDeMedidor = ({ hideSearch, changeInputNumClient, inputForms, setGlobalAlert, setNumIdEstasSinLuz,setNumIdPagoEnLinea}) => {
    const properties = useContext(ApplicationPropertiesContext);
    const [verifReCaptcha, setVerifReCaptcha] = useState(false);
    const [state, dispatch] = useContext(BusquedaClienteContext);
    const [isTableVisible, setIsTableVisible] = useState(false);
    const [inputNMedidor, setInputNMedidor] = useState("");
    const [listDirection, setListDirection] = useState([]);
    const [loading, setLoading] = React.useState(false);
    const [inputValidate, setInputValidate] = React.useState(false);
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);


    function elementInsideAnother() {
        if (getPathName() === "para-estar-informados-completa-tus-datos") {
            return true
        } else {
            return false;
        }
    }

    function handleClick() {
        if (inputNMedidor === "") {
            hideTable()
            setInputValidate(true)
            setGlobalAlert("Complete todos los campos obligatorios.", "warning")
        } else if (!verifReCaptcha) {
            setInputValidate(false)
            setGlobalAlert("Falta validar que no eres un Robot.", "warning")
        } else {
            setInputValidate(false)
            setLoading(true);
            dispatch({
                payload: [inputNMedidor],
                type: ACTIONS.SET_BODY_CLIENTE_MEDIDOR,
            })
        }
    }

    function showTable() {
        if (!isTableVisible) {
            setIsTableVisible(true)
        }
    }

    function hideTable() {
        if (isTableVisible) {
            setIsTableVisible(false)
        }
    }

    useEffect(() => {

        if (state.responseMedidor) {
            setLoading(false)
            const dataResponseMedidor = state.responseMedidor;
            if (dataResponseMedidor.code === 0) {
                setListDirection(dataResponseMedidor?.items);
                showTable()
            } else if (dataResponseMedidor.code > 0) {
                hideTable()
                setGlobalAlert("El Número del Medidor ingresado no existe.", "warning", true, "Advertencia")
            } else {
                hideTable()
                setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning", true, "Advertencia")
            }
        }
    }, [state.responseMedidor]);

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    return (
        <div className="cge-busqueda">
            <CGE.Text
                className="cge-busqueda__main-label"
                size="1"
                text="Filtro de búsqueda"
            />
            <CGE.FormsField
                className="cge-busqueda__width-variation"
                handleChange={(e) => setInputNMedidor(e.target.value)}
                horizontal={true}
                labelName="Número de Medidor:"
                mandatoryElement={true}
                typeElement="input"
                typeFormElement="text"
                hasError={inputValidate}
                msgError="Debes ingresar el número de Medidor"
            />
            <div className="col-md-12 px-0">
                <CGE.FieldRecaptcha
                    horizontal={true}
                    onChange={onChangeReCaptcha}
                    sitekey={properties.api_key_recaptcha}
                />
            </div>
            <div className="d-flex justify-content-center" >
                <CGE.InlineRow>
                    {elementInsideAnother() && <CGE.InlineCol>
                        <CGE.Button
                            label="Volver"
                            onClick={() => { hideSearch(false) }}
                            size="sm"
                            type="secondary"
                        />
                    </CGE.InlineCol>}
                    <CGE.InlineCol>
                        <CGE.Button
                            label="Buscar"
                            onClick={handleClick}
                            size={elementInsideAnother() ? "sm" : false}
                            type="primary"
                        />
                    </CGE.InlineCol>
                </CGE.InlineRow>
            </div>
            {isTableVisible &&
                <>
                    <CGE.Spacing type="md" />
                    <BusquedaTable
                        dataTable={listDirection}
                        flagRoute={0}
                        changeInputNumClient={changeInputNumClient}
                        hideSearch={hideSearch}
                        inputForms={inputForms}
                        setNumIdEstasSinLuz={setNumIdEstasSinLuz}
                        setNumIdPagoEnLinea={setNumIdPagoEnLinea}
                    />
                </>
            }
            {loading && <Loading />}
        </div>
    )
};

const NroDeMedidorWithProvider = ({ hideSearch, changeInputNumClient, inputForms, setGlobalAlert,setNumIdEstasSinLuz,setNumIdPagoEnLinea }) => (
    <BusquedaClienteContextProvider>
        <NroDeMedidor
            changeInputNumClient={changeInputNumClient}
            hideSearch={hideSearch}
            inputForms={inputForms}
            setGlobalAlert={setGlobalAlert}
            setNumIdEstasSinLuz={setNumIdEstasSinLuz}
            setNumIdPagoEnLinea={setNumIdPagoEnLinea}
        />
    </BusquedaClienteContextProvider>
);
export default NroDeMedidorWithProvider;
